import { Component, Inject, Input, ViewContainerRef, ComponentFactoryResolver, ViewChild, OnDestroy } from "@angular/core";
import { Unsubscribe } from 'redux';
import { DoubleParam, ConfDoubleValue, ConfValue } from "../../../shared/models";
import { BaseEntity } from "../../../shared/baseEntity";
import { InputViewModel, RestrictValueChangeEventArgs, ValueChangeEventArgs, PopupService } from "../../../../shared/components";
import { VisualObjectViewModelFactory } from "../shared/visualObjectViewModelFactory";
import { ParamComponent } from "../../shared/paramComponent";
import { ConfigurationSessionManager } from "../../providers/configurationSessionManager";
import { ConfiguratorStore } from "../../providers/configuratorStore";
import { ParameterMandatoryService } from "../shared/parameterMandatoryService";
import { ConfPageSessionService, ConfMessageProvider } from "../../providers";
import { ChangeDetectorRef } from "@angular/core";
import { VisualObjectHelper } from "../shared";

@Component({
  selector: 'double-param',
  templateUrl: './doubleParamComponent.html'
})
export class DoubleParamComponent extends ParamComponent<DoubleParam> {

  confDoubleValue: ConfDoubleValue;
  errors: Array<string>;
  unsubscribeListener: Unsubscribe

  constructor(
    @Inject(ComponentFactoryResolver) public resolver: ComponentFactoryResolver,
    @Inject(VisualObjectViewModelFactory) public viewFactory: VisualObjectViewModelFactory,
    @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfPageSessionService) public confPageSessionService: ConfPageSessionService,
    @Inject(PopupService) public popupService: PopupService,
    @Inject(ParameterMandatoryService) public parameterMandatoryService: ParameterMandatoryService,
    @Inject(ConfMessageProvider) public messagesProvider: ConfMessageProvider,
    @Inject(VisualObjectHelper) public visualObjectHelper: VisualObjectHelper,
    public cd: ChangeDetectorRef
  ) {
    super(confStore, confPageSessionService, popupService, visualObjectHelper, parameterMandatoryService, messagesProvider, cd);
  }

  ngOnInit() {

    this.viewModel = this.viewFactory.create(this.parameter);

    if (this.parameter.placeholder)
      this.viewModel.placeholder = this.parameter.placeholder;

    // Set value on load.
    this.setValue(this.confStore.getConfValue(this.configuration.longId, this.confSessionId, this.parameter.visualObjectId));

    super.ngOnInit();
  }

  public setValue(confValue: BaseEntity) {
    this.confDoubleValue = confValue as ConfDoubleValue;

    if (!this.confDoubleValue)
      return;

    // Set value to view
    this.viewModel.value = this.confDoubleValue.value;

    // Set readonly status to view.
    this.viewModel.readOnly = this.confDoubleValue.isReadOnly;
  }

  onValueChange($event: ValueChangeEventArgs): void {
    super.onValueChange($event);

    // Update value
    this.confStore.setConfValue(this.confDoubleValue, this.confSessionId, $event.value, this.confPageSessionService.includeMandatoryInfo, this.confPageSessionService.isNextStateIncluded);
  }

  onReadOnly($event: RestrictValueChangeEventArgs): void {
    this.confStore.getReadOnlyInfo(this.configurationId, this.confSessionId, this.confDoubleValue, +$event.inValidValue);
  }

  onDisallowed($event: RestrictValueChangeEventArgs): void {
    // TODO: Temporary solution to trigger the events
    //this.appStore.dispatch(
    //this.confStore.setConfValue(this.confDoubleValue, $event.inValidValue);
  }

  public getCurrentValue(): any {

    // If value is different then set it to ConfValue and return the change ConfValue to cause a value change trigger
    if (this.confDoubleValue && this.confDoubleValue.value != this.viewModel.value)
      return this.confDoubleValue.setValue(this.viewModel.value);

    return this.confDoubleValue;
  }

  public setError(errors: Array<string>) {
    this.errors = errors;
  }

}